import { sankeyColors } from '@/components/BudgetCalculator/sankeyColors';
import * as React from 'react';
import { PoweredBySvg } from '@/components/BudgetCalculator/PoweredBySvg';
import NumberFormat from '@/components/common/NumberFormat';

export type CustomNodePayload = {
  // alignment for the label
  align?: 'after' | 'before';
  // the name that will be displayed in the label
  name: string;
  // custom color fo the node
  color?: string;
  // optional override for the displayed value (falls back to computed value)
  displayValue?: number;
  sourceNodes: number[];
  sourceLinks: number[];
  targetLinks: number[];
  targetNodes: number[];
  // the value of the node is the maximum value of the links that are connected to it (whether in or out)
  value: number;
  depth: number;
  x: number;
  dx: number;
  y: number;
  dy: number;
  // whether to show the powered by Finary logo to the bottom left of the node
  poweredBy?: boolean;
};

export const CustomNode = (props: {
  x: number;
  y: number;
  width: number;
  height: number;
  index: number;
  payload: CustomNodePayload;
}) => {
  const value = props.payload.displayValue ?? props.payload.value;
  return (
    <g>
      <rect
        x={props.x + 6}
        y={props.y - 3}
        width={props.width - 12}
        height={props.height + 6}
        fill={props.payload.color || sankeyColors[props.payload.depth % sankeyColors.length]}
        rx={2.5}
      />
      <foreignObject
        x={props.x + (props.payload.align === 'after' ? props.width + 8 : -8)}
        y={props.y + props.height / 2}
        width={1}
        height={1}
        style={{ overflow: 'visible' }}>
        <div
          style={{
            overflow: 'visible',
            display: 'flex',
            justifyContent: props.payload.align === 'after' ? 'flex-start' : 'flex-end',
          }}>
          <div
            style={{
              fontSize: 10,
              fontFamily: 'sans-serif',
              textAlign: 'center',
              backgroundColor: '#f1f5fe80',
              padding: '0.1em 0.5em',
              borderRadius: 4,
              position: 'relative',
              zIndex: 1,
              whiteSpace: 'nowrap',
              display: 'inline-block',
              transform: 'translateY(-50%)',
            }}>
            {props.payload.name ? `${props.payload.name}: ` : ''}
            <NumberFormat value={value} type="currency" currency="EUR" />
          </div>
        </div>
      </foreignObject>
      {props.payload.poweredBy ? (
        <foreignObject x={props.x + 6} y={props.y + props.height + 16} width={149} height={20}>
          {<PoweredBySvg />}
        </foreignObject>
      ) : null}
    </g>
  );
};
